{
	"id": 7819574,
	"numericId": 7819574,
	"collectionId": 784,
	"status": "ACTIVE",
	"sessionTime": 0,
	"startTime": "2026-05-20T06:08:40.381Z",
	"examBreak": null,
	"timeAllocation": null,
	"progressList": [],
	"sessionItems": [
		{
			"id": 103627,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "The first step in navigating ethical dilemmas is to understand how your values and dispositions can affect your decisions. Educators’ decisions are influenced by two frameworks: dispositional and regulatory. The influence of each framework varies, and educators can be influenced more strongly by one framework than by another. Reflect on what influenced the decisions of Ms. Kim’s colleagues.",
				"title": "Scenario: Reflect",
				"question": "Were Ms. Kim’s colleagues influenced more by their dispositional framework or the regulatory framework?",
				"instruction": "**Directions:** Select each of the following two frameworks to read its definition. Then answer the question by choosing one of the frameworks and selecting Submit. If needed, you can try again and select the alternative framework to reveal the explanation."
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "scenario_reflect_framework_choice",
				"language": "en-US",
				"position": 4,
				"sourceId": 2040
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "2e4531d5-2c5d-4385-ac11-de273ce7476b",
						"isCorrect": true
					},
					{
						"choiceId": "04c18985-a4c1-461e-b563-e9e88e2f2697",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "2e4531d5-2c5d-4385-ac11-de273ce7476b",
					"detailed": {
						"text": "Ms. Kim’s colleagues are influenced more by the dispositional framework than the regulatory framework. Mr. Taylor’s decisions are shaped by his personal values and beliefs about collegial boundaries and professional respect. As a new teacher, he expresses concern about “overstepping,” which reflects a disposition toward caution, humility, and respect for colleagues rather than an appeal to formal expectations or policies. Ms. Patel’s dominant influence is dispositional, valuing privacy, autonomy, and non-interference. Ms. Martinez relies heavily on her personal relationship and past experiences with Ms. Kim. Her decisions are shaped by loyalty, empathy, and belief in Ms. Kim’s character."
					},
					"language": "en-US"
				},
				{
					"type": "STATIC",
					"choiceId": "04c18985-a4c1-461e-b563-e9e88e2f2697",
					"detailed": {
						"text": "Very little in the conversation of Ms. Kim’s colleagues reflects a regulatory framework, such as ethical duty to students, professional standards, or mandated steps for addressing instructional concerns. The discussion only begins to shift when the group collectively acknowledges that “pretending we don’t notice” may no longer be ethically defensible."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "2e4531d5-2c5d-4385-ac11-de273ce7476b",
						"icon": "heart-handshake",
						"text": "Influenced More by Dispositional Framework",
						"description": "The personal and professional attitudes, values, and beliefs that inform a professional educator’s decision making.",
						"numFirstSelections": 0
					},
					{
						"id": "04c18985-a4c1-461e-b563-e9e88e2f2697",
						"icon": "scale",
						"text": "Influenced More by Regulatory Framework",
						"description": "School or district policies, state statutes, and criminal laws that form the basis for conduct absolutes and inform a professional educator’s decision making.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false
			},
			"tags": [
				{
					"id": 37088,
					"label": "Module 2: The Professional Educator",
					"title": "Module 2: The Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103628,
			"versionId": 1,
			"blockId": null,
			"type": "SATA",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "The second step in navigating ethical dilemmas is exploring the risks to the ethical principles.",
				"title": "Scenario: Explore",
				"question": "Which of the following ethical principles were at immediate risk for Ms. Kim and her colleagues in the scenario? Select all that apply.",
				"instruction": "**Directions:** Select each of the following nine expandable text buttons to review information about each principle of ethical decision making.",
				"ethicalPrinciples": {
					"items": [
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-01-promoting-solution-discovery-illustration-v2.png"
								}
							],
							"title": "**P**romoting Solution Discovery",
							"description": "Creating opportunities for self-advocacy and problem resolution is a foundational principle in ethical decision making. Educators should refer students or colleagues to suitable school resources and officials and ensure that these students and colleagues follow up, rather than handle issues themselves. Not only is this in the best interest of those involved, but it also allows situations to be handled objectively and avoids blurring the scope of the educator’s position with that of more expansive roles such as those of counselor, confidant, caregiver, and rescuer. The primary role of the professional educator is most often associated with the tasks of teaching and learning.\n\n**Guiding Questions**\n- What are the inherent professional risks in attempting to fix the immediate or long-term challenges, problems, and obstacles that students, colleagues, or other learning community stakeholders encounter?\n- Am I accepting responsibilities, performing duties, or providing services that correspond with my training and area of certification?\n- How can I help colleagues when their role as a professional educator overlaps with other societal expectations?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-02-risk-mitigation-illustration-v2.png"
								}
							],
							"title": "**R**isk Mitigation",
							"description": "Since educators provide services directly to minors who remain under their care and supervision for extended periods of time without the presence of parents or guardians, the field of education has many professional risks and vulnerabilities. It is important that all educators continually reflect on how to best mitigate risks that may compromise their professional and personal credibility, career goals, personal well-being, and effectiveness as a teacher.\n\n**Guiding Questions**\n- How can a seemingly innocuous and insignificant decision have the potential to put my educational practice at risk?\n- What professional-risk situations inherent in my educational practice do I need to carefully consider (for example, chaperoning an overnight field trip, being approached by a student for personal advice)?\n- What conversations can I have with my colleagues to help identify ways to mitigate risks in situations that we commonly encounter?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-03-objectivity-neutrality-maintained-illustration-v3.png"
								}
							],
							"title": "**O**bjectivity and Neutrality Are Maintained",
							"description": "By maintaining objectivity and neutrality, professional educators should be able to evaluate a situation without emotional entanglements or bias. Remaining objective and neutral mitigates the risks of over-identifying with one party, becoming too focused on the needs of an individual, or advocating for a singular interest instead of advocating for solutions.\n\n**Guiding Questions**\n- When encountering competing tensions (for example, school policy versus what I think is best for a student or colleague; parental influence versus administrative influence), how can I determine the best course of action?\n- How can I remain objective and neutral when I have multiple relationships in the schooling community and as a community member (for example, I’m a friend of one of my student’s parents; I am a youth group leader at a student’s religious center; I coach a student on a club volleyball team during the summer)?\n- How can I best caution a colleague if I suspect the colleague is becoming overwhelmed by the needs of a student?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-04-ensuring-student-welfare-illustration-v2.png"
								}
							],
							"title": "**E**nsuring Student Welfare",
							"description": "Since the individuals receiving services are minors and the educators have been ascribed in loco parentis responsibilities, the primary responsibility of educators is to ensure the students’ safety and welfare. The scope of this charge is not just limited to physical safety, but it also includes emotional, intellectual, psychological, and sexual safety.\n\n**Guiding Questions**\n- Am I doing everything in my power to establish a safe and secure environment for academic, personal, and social growth to occur?\n- Am I willing to safeguard students from duress even if I am not directly responsible for the students?\n- How can I best confront a colleague regarding acts, either committed or omitted, that have the potential to compromise a student’s welfare?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-05-transparency-actions-communications-illustration-v2.png"
								}
							],
							"title": "**T**ransparency in Actions and Communications",
							"description": "Educators must be transparent in their actions and communications. Transparency establishes openness, accountability, trust, credibility, and boundaries. Failure to be sufficiently transparent with appropriate stakeholders (for example, parents, guardians, students, colleagues, administrators) may result in misinterpretation of motives or the appearance of impropriety. Transparency is the best way for educators to ensure that their decisions and behaviors can withstand public scrutiny.\n\n**Guiding Questions**\n- How can I ensure that all communications with students, including digital and electronic communications, are conducted with transparency?\n- How can I balance the need for transparency in my actions and communications with protecting highly confidential information that I am expected to retain (which is considered a “qualified privilege” by the courts)?\n- How do I best approach a colleague about rumors of impropriety that are a result of their lack of transparency in decision making?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-06-boundaries-role-time-place-illustration-v2.png"
								}
							],
							"title": "**H**onoring the Boundaries of Role, Time, and Place",
							"description": "Boundaries encompass the verbal, physical, emotional, and social distances that an educator must maintain to ensure security, structure, and predictability in an educational environment. Most often, the boundaries that are transgressed relate to role, time, and place. By respecting the functions and limits of contracted roles, as well as the working hours and location of the learning environment, secure boundaries are in place for all members of the school community.\n\n**Guiding Questions**\n- In reflecting on my educational practice, which dispositions most risk eroding professional boundaries (for example, assisting with students’ personal challenges, extending academic support beyond school hours, engaging in extracurricular activities, communication with students, parents, and colleagues)?\n- Am I thinking about all my interactions with students (for example, in the school, in the community, and at social functions) as an extension of my professional responsibilities as an educator?\n- How can my colleagues and I openly discuss and agree on boundaries that are most appropriate for our educational context?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-07-integrity-profession-illustration-v2.png"
								}
							],
							"title": "**I**ntegrity of the Profession Is Promoted by the Educator",
							"description": "Educators’ actions reflect on the schooling community, the district, and the profession. An individual educator’s positive actions have the potential to inspire public confidence in the profession. On the other hand, negative actions can cast shadows of doubt and distrust by undermining the effectiveness of a healthy educational structure. The professional educator has an obligation to hold himself or herself responsible for ethical conduct. The educator should take steps when he or she has reason to believe that another educator may be approaching or engaged in an ethically compromising situation.\n\n**Guiding Questions**\n- How often am I reflecting on the daily decisions that I make as a professional educator and how those decisions may affect the integrity of the profession?\n- What steps can I take when I believe that a colleague may be approaching or involved in an ethically compromising situation?\n- How can I best advocate for the profession while also working to reconcile points of disagreement within the school or district?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-08-code-ethics-fidelity-illustration-v2.png"
								}
							],
							"title": "**C**ode of Ethics for Educators Is Maintained with Fidelity",
							"description": "Having an ethics code is a proclamation that a profession is better off when ethical standards are not based solely on individual assessments of what is or is not ethically acceptable but reflect consensus among members on a common purpose. For the education discipline, the *Model Code of Ethics for Educators* (*MCEE*) is a guide for what educators should expect of themselves and one another and should be maintained with fidelity. The *MCEE* assists educators in their efforts to resolve ethical dilemmas and helps educators defend their decisions to schooling-community constituents, institutions, courts, and any other agency that would encourage them to go against the values of the profession. The formal standards are not a substitute for an active, deliberate, and creative approach to fulfilling your ethical responsibilities. They prompt, guide, and inform an educator’s ethical decision-making; they do not serve as a substitute for it.\n\n**Guiding Questions**\n- How can educators from my school or district work together to identify common ethical dilemmas that we encounter?\n- Is there a way to use the *MCEE* as a prompt to discuss resolutions to those ethical dilemmas?\n- Since ethical dilemmas are often situational, contextual, and likely to change over time, how can the *MCEE* continue to guide and inform my decision making as I engage in the practical realities of my work?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-09-stewardship-law-public-trust-illustration-v2.png"
								}
							],
							"title": "**S**tewardship of the Law and Public Trust",
							"description": "Employment policies, licensure statutes, and community laws represent conduct absolutes that have originated from a history of judicial activity. They represent the lowest standard of acceptable behavior deemed necessary to safeguard community members. However, the professional educator is aware that trust in the profession depends on a level of conduct and responsibility that may be higher than what is required by law.\n\n**Guiding Questions**\n- How will relevant procedures, policies, and laws inform my decision making when I encounter ethical dilemmas?\n- It has been said that misconduct is not an event but a process. Will I be able to identify those situations where a series of gradual and unintentional missteps could lead to the transgression of a conduct absolute?\n- What steps can I take when I believe that a colleague may be approaching or involved in actions that may lead to the transgression of a policy, statute, or law?"
						}
					],
					"title": "Ethical Principles"
				}
			},
			"metadata": {
				"type": "SATA",
				"ui_type": "scenario_principle_sata_activity",
				"language": "en-US",
				"position": 5,
				"sourceId": 2050
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "c1dcdeee-8ad6-4e39-8625-6277414c0327",
						"isCorrect": true
					},
					{
						"choiceId": "7002432e-e8c7-406c-b42b-ede045479499",
						"isCorrect": false
					},
					{
						"choiceId": "049b981f-0bdf-412a-b8ed-0198aafff30a",
						"isCorrect": true
					},
					{
						"choiceId": "be8de3e1-b8cb-4e30-8fb5-6009ae6080d9",
						"isCorrect": true
					},
					{
						"choiceId": "24ee3c81-197d-406e-8e94-a4bad57dfe00",
						"isCorrect": true
					},
					{
						"choiceId": "e21c32e6-05be-4219-95a7-8d3264bd9647",
						"isCorrect": false
					},
					{
						"choiceId": "eb738881-336d-4d7c-a90e-6249efe9c123",
						"isCorrect": true
					},
					{
						"choiceId": "515e0f2e-67d3-44d6-b89c-88ea025d561a",
						"isCorrect": false
					},
					{
						"choiceId": "22a98eee-51d6-4700-96f2-999cc2df342e",
						"isCorrect": true
					}
				],
				"selection": {
					"max": 9,
					"min": 1
				}
			},
			"feedback": null,
			"response": {
				"type": "MULTIPLE_SELECT",
				"choices": [
					{
						"id": "c1dcdeee-8ad6-4e39-8625-6277414c0327",
						"text": "Promoting Solution Discovery",
						"numFirstSelections": 0
					},
					{
						"id": "7002432e-e8c7-406c-b42b-ede045479499",
						"text": "Risk Mitigation",
						"numFirstSelections": 0
					},
					{
						"id": "049b981f-0bdf-412a-b8ed-0198aafff30a",
						"text": "Objectivity and Neutrality Are Maintained",
						"numFirstSelections": 0
					},
					{
						"id": "be8de3e1-b8cb-4e30-8fb5-6009ae6080d9",
						"text": "Ensuring Student Welfare",
						"numFirstSelections": 0
					},
					{
						"id": "24ee3c81-197d-406e-8e94-a4bad57dfe00",
						"text": "Transparency in Actions and Communications",
						"numFirstSelections": 0
					},
					{
						"id": "e21c32e6-05be-4219-95a7-8d3264bd9647",
						"text": "Honoring the Boundaries of Role, Time, and Place",
						"numFirstSelections": 0
					},
					{
						"id": "eb738881-336d-4d7c-a90e-6249efe9c123",
						"text": "Integrity of the Profession Is Promoted by the Educator",
						"numFirstSelections": 0
					},
					{
						"id": "515e0f2e-67d3-44d6-b89c-88ea025d561a",
						"text": "Code of Ethics for Educators Is Maintained with Fidelity",
						"numFirstSelections": 0
					},
					{
						"id": "22a98eee-51d6-4700-96f2-999cc2df342e",
						"text": "Stewardship of the Law and Public Trust",
						"numFirstSelections": 0
					}
				],
				"shuffle": false
			},
			"tags": [
				{
					"id": 37088,
					"label": "Module 2: The Professional Educator",
					"title": "Module 2: The Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103629,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"overview": {
					"title": "The Professional Educator",
					"summary": "This module contains two activities and a five-question end-of-module knowledge check. It will take approximately 30 to 40 minutes to complete the entire module.",
					"moduleNumber": 2,
					"activityCount": 2,
					"knowledgeCheckCount": 5,
					"estimatedDurationMinutes": 35
				},
				"moduleOutline": {
					"heading": "Module Outline",
					"sections": [
						{
							"items": [
								{
									"icon": "circle-play",
									"title": "Video"
								},
								{
									"icon": "messages-square",
									"title": "Perspectives"
								},
								{
									"icon": "square-pen",
									"title": "Reflect"
								},
								{
									"icon": "compass",
									"title": "Explore"
								},
								{
									"icon": "clipboard-check",
									"title": "Review"
								},
								{
									"icon": "chart-column-increasing",
									"title": "Analysis"
								}
							],
							"title": "Scenario: A Colleague’s Role"
						},
						{
							"title": "Ethical Situations: Educator Professional Integrity"
						},
						{
							"title": "Module 2 Summary"
						}
					]
				},
				"learningObjectives": {
					"heading": "Learning Objectives",
					"objectives": [
						"Distinguishing between actions appropriate to the educator role and those requiring referral",
						"Analyzing a scenario to differentiate how dispositional and regulatory frameworks influence decision making and determining an appropriate course of action",
						"Evaluating competing tensions to select actions aligned with ethical principles",
						"Applying decision criteria aligned to the *Model Code of Ethics for Educators* (*MCEE*) to resolve ethical scenarios"
					]
				}
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "module_intro",
				"language": "en-US",
				"position": 1,
				"sourceId": 2010
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37088,
					"label": "Module 2: The Professional Educator",
					"title": "Module 2: The Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103630,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten situations that require you to decide if an action upholds educator integrity or harms educator integrity. After each situation, you will be presented with two flip cards that describe whether the action in the situation upholds or harms the educator’s integrity. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Educator Professional Integrity",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Correct. Mr. Toth maintains objectivity and transparency, and he safeguards fair, valid grading practices by adhering to policy and citing evidence."
							},
							"label": "Integrity Upheld"
						},
						{
							"id": "B",
							"back": {
								"text": "Incorrect. Being transparent about established grading standards does not undermine integrity. Yielding to pressure by adding extra credit points that are not aligned to the current grading structure would compromise fairness and public trust."
							},
							"label": "Integrity Harmed"
						}
					],
					"count": 10,
					"setup": "A parent requests extra credit options to improve their child’s grade. Mr. Toth, the teacher, explains the grading policy, provides evidence-based feedback, and offers legitimate academic support, without inflating the student’s grades.",
					"title": "Situation 2: Parent Pressure",
					"number": 2,
					"prompt": "Does this action uphold or harm the educator’s professional integrity?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 9,
				"sourceId": 2090
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37088,
					"label": "Module 2: The Professional Educator",
					"title": "Module 2: The Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103631,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten situations that require you to decide if an action upholds educator integrity or harms educator integrity. After each situation, you will be presented with two flip cards that describe whether the action in the situation upholds or harms the educator’s integrity. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Educator Professional Integrity",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Incorrect. Though the school may benefit from the donation, personal endorsements that imply connections to the school community blur the line between educator and advertiser. Remaining neutral avoids conflicts of interest and maintains the public’s confidence in educator impartiality."
							},
							"label": "Integrity Upheld"
						},
						{
							"id": "B",
							"back": {
								"text": "Correct. Integrity is harmed by a conflict of interest. Declining the endorsement and directing the business to district partnership channels is appropriate."
							},
							"label": "Integrity Harmed"
						}
					],
					"count": 10,
					"setup": "A local tutoring business asks Mr. Davis, a teacher, to appear in an ad since he is a trusted school professional and offers a donation to the school if he agrees. Mr. Davis agrees.",
					"title": "Situation 5: Donation",
					"number": 5,
					"prompt": "Does this action uphold or harm the educator’s professional integrity?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 12,
				"sourceId": 2120
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37088,
					"label": "Module 2: The Professional Educator",
					"title": "Module 2: The Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103632,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will consider a scenario involving an educator whose teaching style changes over a short period of time, causing a decline in student engagement. A group of colleagues meet and express concern about the change.\n\nFirst, you will review a video that shows the shift in the educator’s behavior and how that affects her students and colleagues. Then, you will gain further insight by reviewing two videos showing the perspectives of people involved in the scenario. After observing the videos, you will reflect on and explore the ethical dilemmas depicted in the scenario.",
				"media": [
					{
						"type": "VIDEO",
						"title": "Seventh Grade Science Video",
						"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-2/m2_scenario.mp4",
						"transcript": "**Seventh Grade Science Lesson**\n\nThe video consists of two scenes.\n\nThe first scene shows Ms. Kim and four students from her class around a lab table. There is a science experiment on the table.\n\nMs. Kim: Thank you, Pedro. Good observation. Yes, the car did go farther when we raised the ramp, but what does that tell us? Let’s break it down. If the ramp height is what we change, what variable is that?\n\nClass (in unison): Independent variable.\n\nMs. Kim: Exactly, and Emma made a great point earlier. Emma said, “But if the ramp is bumpy, won’t that change things too?” That’s why we control our surface. So, here’s your challenge. Predict how the distance traveled changes when we adjust the ramp angle by 10 degrees, but defend your prediction using science, not guesses! That’s what people who work in science do. Now, go investigate.\n\nA few weeks later\n\nThe second scene shows Ms. Kim sitting at a desk at the front of her classroom. A student, Jennifer, raises her hand and asks Ms. Kim a question.\n\nJennifer: Ms. Kim, I don’t understand how to find the independent and dependent variable when comparing the momentum of two objects going down the ramp.\n\nMs. Kim [speaks while looking down at an open book on her desk]: Jennifer, it’s in the chapter. Read the section on variables and fill out the chart. I can’t walk through it right now. If you’re still confused, ask your group.",
						"transcriptTitle": "Transcript for Seventh Grade Science video",
						"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
					}
				],
				"title": "Scenario: A Colleague’s Role",
				"instruction": "**Directions:** Review the following video to learn about the scenario. Select the play button to begin. Use the video controls when needed."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_presentation",
				"language": "en-US",
				"position": 2,
				"sourceId": 2020
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37088,
					"label": "Module 2: The Professional Educator",
					"title": "Module 2: The Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103633,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "Gain further insight by reviewing the following video showing the perspectives of Ms. Kim’s colleagues.",
				"items": [
					{
						"media": {
							"type": "VIDEO",
							"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-2/m2_perspectives.mp4",
							"transcript": "**Teacher’s Lounge**\n\nThe video shows a conversation between three teachers, Mr. Taylor, Ms. Patel, and Ms. Martinez. The three teachers are sitting around a table and discussing Ms. Kim and the students in her science class.\n\nMr. Taylor: I had to cover Ms. Kim’s science class again today. Her kids seem so confused about finding independent and dependent variables. One of them asked me if they should just guess their data collection. I’m new. I don’t want to overstep. But something’s not right, and her students are getting behind.\n\nMs. Patel: I know that everyone has a life, Mr. Taylor. Everyone hits a slump. I mean, I wouldn’t want anyone poking around in my business. If it turns into something serious, the administrators will deal with it. That’s what they do.\n\nMs. Martinez: She’ll be fine. It’s Ms. Kim. She made science fun, and kids used to run into that classroom to see what she’d set up. She’s just overwhelmed. The kids are just tired.\n\nMr. Taylor: Ms. Martinez, the kids aren’t tired. They’re stressed. One of them asked me why they weren’t doing hands-on labs anymore. They feel lost.\n\nMs. Martinez: Some students mentioned that to me too. They asked if they were going to get behind before the next test. Ms. Patel, what do you think?\n\n[Ms. Patel picks up a stack of papers and shuffles them.] Ms. Patel: I mean, I keep telling myself it’s not our business, but I don’t know. It’s getting harder to pretend we don’t notice.\n\nMs. Martinez: I’ve never seen her like this. She always bounces back. That’s what I keep telling myself, but what if she doesn’t this time?\n\nMr. Taylor: You’re the closest to her, Ms. Martinez. If anyone can reach her, it’s you.\n\nMs. Patel: Maybe . . . maybe it doesn’t have to be an intervention. Just to check in.",
							"transcriptTitle": "Transcript for Teacher’s Lounge video",
							"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
						},
						"title": "Teacher’s Lounge"
					}
				],
				"title": "Scenario: Perspectives",
				"instruction": "**Directions:** Review the following video to learn about the perspectives of Mr. Taylor, Ms. Patel, and Ms. Martinez. Select the play button to begin. Use the video controls when needed."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_perspective_resource_set",
				"language": "en-US",
				"position": 3,
				"sourceId": 2030
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37088,
					"label": "Module 2: The Professional Educator",
					"title": "Module 2: The Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103634,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "",
				"items": [
					{
						"media": [
							{
								"type": "IMAGE",
								"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-2/m2_ms_patel.png"
							}
						],
						"title": "Ms. Patel",
						"analysis": {
							"text": "Ms. Patel has the common educator mindset of respecting personal privacy. However, she is following this so strongly that she is avoiding responsibility. She rationalizes inaction as a kindness by implying the following.\n- I wouldn’t want someone interfering with my personal struggles.\n- Administrators handle the real problems.\nHowever, students are experiencing academic decline, and Ms. Patel should prioritize student welfare over her own comfort. Ms. Patel fails to consider the following.\n- Ethical responsibility requires acting even when situations feel personal.\n- Overreliance on administrative intervention deflects professional responsibility.\nEducators may be uncomfortable initiating difficult conversations, but ignoring clear signs risks student welfare and professional integrity.",
							"title": "Analysis"
						},
						"questions": {
							"text": "The following are reflective questions that Ms. Patel could ask herself.\n- Am I using my respect for privacy to avoid a potentially uncomfortable professional duty?\n- Am I prioritizing my discomfort over the students’ academic needs?\n- If I were the one struggling, would I truly want my colleagues to stay silent or instead to check in with me with care?\n- Is relying on the administration an attempt to shift responsibility rather than share it?\n- How might my assumptions about Ms. Kim’s past excellence be affecting my objectivity?",
							"title": "Questions"
						},
						"keyTakeaway": {
							"text": "**Respect for colleagues does not mean avoiding hard conversations.**\n Educators have a professional obligation, grounded in the *MCEE*, to act when student welfare is at risk, even if doing so feels personally awkward.",
							"title": "Key Takeaway"
						}
					},
					{
						"media": [
							{
								"type": "IMAGE",
								"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-2/m2_mr_taylor.png"
							}
						],
						"title": "Mr. Taylor",
						"analysis": {
							"text": "Mr. Taylor is influenced by the following concerns.\n- He is uncertain of his place as a newcomer.\n- He is worried that any actions he takes may seem inappropriate or meddlesome.\n- He is protective of the students but hesitant to involve himself in interpersonal dynamics.\nMr. Taylor’s comments reveal both clarity and paralysis.\n- He implies that learning has all but stopped in Ms. Kim’s classroom.\n- He says, “I don’t want to overstep.”\nEducators are always “onstage,” and when someone falters, the impact is immediate and visible. New teachers often struggle with knowing when and how they are allowed to intervene. Mr. Taylor is aware of what is happening; he just does not believe it is his place to act.",
							"title": "Analysis"
						},
						"questions": {
							"text": "The following are reflective questions that Mr. Taylor could ask himself.\n- Does my status as a new teacher remove my responsibility to students?\n- If student learning is suffering, what is my ethical obligation?\n- Is my silence protecting Ms. Kim or enabling harm to continue?\n- What would I expect a colleague to do if I were the one struggling?\n- How can I raise concerns without overstepping or seeming accusatory?",
							"title": "Questions"
						},
						"keyTakeaway": {
							"text": "**Being new does not negate professional responsibility.**\nThe *MCEE* says that educators, regardless of tenure, must take “appropriate measures” when student learning is at risk. Ethical action is not reserved for the experienced; it is required of everyone.",
							"title": "Key Takeaway"
						}
					},
					{
						"media": [
							{
								"type": "IMAGE",
								"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-2/m2_ms_martinez.png"
							}
						],
						"title": "Ms. Martinez",
						"analysis": {
							"text": "Ms. Martinez displays the following.\n- Loyalty and admiration for Ms. Kim (for example, she says that Ms. Kim “made science fun”)\n- Emotional reluctance to believe something is seriously wrong\n- A belief that past excellence equals present competence\n- An internal conflict between personal loyalty and professional responsibility\nHer insistence that Ms. Kim will “be fine” and “always bounces back” suggests denial and is influenced by emotional entanglement and misplaced trust. By relying on past experiences with Ms. Kim as evidence of why she should not act, Ms. Martinez has jeopardized her objectivity.",
							"title": "Analysis"
						},
						"questions": {
							"text": "The following are reflective questions that Ms. Martinez could ask herself.\n- Am I basing my judgment on Ms. Kim’s past behavior rather than on current evidence?\n- Is loyalty making me ignore the impact on students?\n- Are my beliefs about letting her work it out on her own grounded in professionalism or comfort?\n- How would the *MCEE* guide me in a situation where student welfare is compromised?",
							"title": "Questions"
						},
						"keyTakeaway": {
							"text": "**Support is not the same as silence.**\nLoyalty and collegiality do not excuse ignoring signs of declining effectiveness. Ethical practice requires honest intervention, even when it feels uncomfortable or disloyal.",
							"title": "Key Takeaway"
						}
					}
				],
				"title": "Scenario: Analysis",
				"instruction": "**Directions:** Select each of the following three tabs to review the feedback of Ms. Patel, Mr. Taylor, and Ms. Martinez’s involvement in the scenario. Select each of the expandable text buttons within each tab to review the information about each person."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_analysis_cards",
				"language": "en-US",
				"position": 7,
				"sourceId": 2070
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37088,
					"label": "Module 2: The Professional Educator",
					"title": "Module 2: The Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103635,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten situations that require you to decide if an action upholds educator integrity or harms educator integrity. After each situation, you will be presented with two flip cards that describe whether the action in the situation upholds or harms the educator’s integrity. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Educator Professional Integrity",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Incorrect. Public posting of copyrighted works is usually improper without permission. Teachers should familiarize themselves with school policies for using copyrighted material."
							},
							"label": "Integrity Upheld"
						},
						{
							"id": "B",
							"back": {
								"text": "Correct. Violating the rules of intellectual property (IP) and copyright and failing to appropriately steward protected materials harms integrity."
							},
							"label": "Integrity Harmed"
						}
					],
					"count": 10,
					"setup": "Ms. Nguyen, a fifth-grade teacher, posts copyrighted materials on her public class web page for easy access.",
					"title": "Situation 8: Digital Sharing",
					"number": 8,
					"prompt": "Does this action uphold or harm the educator’s professional integrity?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 15,
				"sourceId": 2150
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37088,
					"label": "Module 2: The Professional Educator",
					"title": "Module 2: The Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103636,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten situations that require you to decide if an action upholds educator integrity or harms educator integrity. After each situation, you will be presented with two flip cards that describe whether the action in the situation upholds or harms the educator’s integrity. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Educator Professional Integrity",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Correct. Ms. Hernandez maintains her role, protects student welfare, and promotes solution discovery by connecting the student to qualified support and documenting the concern."
							},
							"label": "Integrity Upheld"
						},
						{
							"id": "B",
							"back": {
								"text": "Incorrect. Keeping the matter secret or taking on a counselor role would blur boundaries and increase risk. Referral and documentation are the correct actions."
							},
							"label": "Integrity Harmed"
						}
					],
					"count": 10,
					"setup": "A student shares personal emotional struggles with Ms. Hernandez, a paraeducator. She listens supportively and then refers the student to the school counselor and documents the concern appropriately.",
					"title": "Situation 1: Student Disclosure",
					"number": 1,
					"prompt": "Does this action uphold or harm the educator’s professional integrity?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 8,
				"sourceId": 2080
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37088,
					"label": "Module 2: The Professional Educator",
					"title": "Module 2: The Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103637,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "Review the ethical principles to determine whether each ethical principle was at immediate risk for the educators in the scenario.",
				"items": [
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Rather than scaffolding Jennifer’s understanding or directing her to appropriate supports (clarification, peer discussion, office hours, tutoring), Ms. Kim dismisses the question. This models avoidance rather than inquiry."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-01-promoting-solution-discovery-illustration-v2.png"
								}
							],
							"title": "Promoting Solution Discovery"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "Not At Immediate Risk",
							"explanation": ""
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-02-risk-mitigation-illustration-v2.png"
								}
							],
							"title": "Risk Mitigation"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Ms. Martinez’s close relationship with Ms. Kim strongly influences her judgment. She minimizes current evidence of student disengagement by relying on Ms. Kim’s past performance and character. Emotional loyalty compromises objectivity."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-03-objectivity-neutrality-maintained-illustration-v3.png"
								}
							],
							"title": "Objectivity and Neutrality Are Maintained"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "To ensure student welfare, Ms. Martinez and her colleagues should ask themselves the following questions.\n- Am I willing to advocate for students even if I am not directly responsible for the students?\n- How can I approach the issue with Ms. Kim in order to preserve the students’ academic welfare?"
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-04-ensuring-student-welfare-illustration-v2.png"
								}
							],
							"title": "Ensuring Student Welfare"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Ms. Martinez and her colleagues are reluctant to get involved. Transparency is at risk."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-05-transparency-actions-communications-illustration-v2.png"
								}
							],
							"title": "Transparency in Actions and Communications"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "Not At Immediate Risk",
							"explanation": ""
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-06-boundaries-role-time-place-illustration-v2.png"
								}
							],
							"title": "Honoring the Boundaries of Role, Time, and Place"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Ms. Kim’s disengagement contrasts with professional expectations of responsiveness and instructional responsibility. Ms. Martinez’s reluctance to confront or support Ms. Kim professionally, despite mounting concerns, risks prioritizing personal relationships over ethical responsibility to students and the profession."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-07-integrity-profession-illustration-v2.png"
								}
							],
							"title": "Integrity of the Profession Is Promoted by the Educator"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "Not At Immediate Risk",
							"explanation": ""
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-08-code-ethics-fidelity-illustration-v2.png"
								}
							],
							"title": "Code of Ethics for Educators Is Maintained with Fidelity"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Although no law or policy violation is cited, Ms. Patel’s reliance on administrators as a shield rather than as part of a collaborative ethical process risks erosion of public trust in educators’ self-regulation."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-09-stewardship-law-public-trust-illustration-v2.png"
								}
							],
							"title": "Stewardship of the Law and Public Trust"
						}
					}
				],
				"title": "Scenario: Review",
				"instruction": "**Directions:** Select each of the following nine flip cards to explore whether each ethical principle was at immediate risk for Ms. Kim and her colleagues in the scenario. Each of the nine cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_principle_review_cards",
				"language": "en-US",
				"position": 6,
				"sourceId": 2060
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37088,
					"label": "Module 2: The Professional Educator",
					"title": "Module 2: The Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103638,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten situations that require you to decide if an action upholds educator integrity or harms educator integrity. After each situation, you will be presented with two flip cards that describe whether the action in the situation upholds or harms the educator’s integrity. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Educator Professional Integrity",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Incorrect. Serving as a mentor creates a dual relationship that compromises objectivity and risks favoritism."
							},
							"label": "Integrity Upheld"
						},
						{
							"id": "B",
							"back": {
								"text": "Correct. Integrity is harmed by the dual role. Disclosing the relationship and requesting reassignment preserves fairness and professional boundaries."
							},
							"label": "Integrity Harmed"
						}
					],
					"count": 10,
					"setup": "Mr. Lee, a high school teacher and department chair, is assigned to serve as a mentor to a new educator with whom he recently began a dating relationship. Mr. Lee does not disclose the relationship to administration and begins mentoring the new educator.",
					"title": "Situation 3: Mentor",
					"number": 3,
					"prompt": "Does this action uphold or harm the educator’s professional integrity?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 10,
				"sourceId": 2100
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37088,
					"label": "Module 2: The Professional Educator",
					"title": "Module 2: The Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103639,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten situations that require you to decide if an action upholds educator integrity or harms educator integrity. After each situation, you will be presented with two flip cards that describe whether the action in the situation upholds or harms the educator’s integrity. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Educator Professional Integrity",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Correct. He safeguards test security, respects intellectual property, and supports a colleague without compromising assessment validity."
							},
							"label": "Integrity Upheld"
						},
						{
							"id": "B",
							"back": {
								"text": "Incorrect. Sharing secure materials would violate assessment integrity and public trust."
							},
							"label": "Integrity Harmed"
						}
					],
					"count": 10,
					"setup": "Mr. Williams, an ELA teacher, is asked by a former colleague to share the confidential scoring guide for a district-approved performance assessment. He offers general tips to prepare for the assessment but does not release secure materials.",
					"title": "Situation 6: Performance Task",
					"number": 6,
					"prompt": "Does this action uphold or harm the educator’s professional integrity?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 13,
				"sourceId": 2130
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37088,
					"label": "Module 2: The Professional Educator",
					"title": "Module 2: The Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103640,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten situations that require you to decide if an action upholds educator integrity or harms educator integrity. After each situation, you will be presented with two flip cards that describe whether the action in the situation upholds or harms the educator’s integrity. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Educator Professional Integrity",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Incorrect. Accepting would create a conflict of interest and the perception that grades or access to support are tied to money."
							},
							"label": "Integrity Upheld"
						},
						{
							"id": "B",
							"back": {
								"text": "Correct. Integrity is harmed by the dual role. Because she is the student’s current teacher, Ms. Rodriguez should direct families to approved tutoring options with a different tutor."
							},
							"label": "Integrity Harmed"
						}
					],
					"count": 10,
					"setup": "Ms. Rodriguez, a science teacher, accepts an offer of premium pay to tutor a student she currently teaches. She tells the student’s parents that she would be a good tutor “because she knows the tests.”",
					"title": "Situation 7: Tutoring",
					"number": 7,
					"prompt": "Does this action uphold or harm the educator’s professional integrity?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 14,
				"sourceId": 2140
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37088,
					"label": "Module 2: The Professional Educator",
					"title": "Module 2: The Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103641,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten situations that require you to decide if an action upholds educator integrity or harms educator integrity. After each situation, you will be presented with two flip cards that describe whether the action in the situation upholds or harms the educator’s integrity. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Educator Professional Integrity",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Incorrect. Routing party expenses through a student activity account, even when done with good intentions, misuses resources and violates policy."
							},
							"label": "Integrity Upheld"
						},
						{
							"id": "B",
							"back": {
								"text": "Correct. Misusing funds violates policy. Educators must handle funds transparently and lawfully to maintain public trust."
							},
							"label": "Integrity Harmed"
						}
					],
					"count": 10,
					"setup": "Fine arts staff plan a large off-site celebration and ask Ms. Garcia, head of the music department, to process invoices. The student activities choir account has a surplus, and Ms. Garcia charges that account rather than following the usual accounting process.",
					"title": "Situation 4: Celebration",
					"number": 4,
					"prompt": "Does this action uphold or harm the educator’s professional integrity?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 11,
				"sourceId": 2110
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37088,
					"label": "Module 2: The Professional Educator",
					"title": "Module 2: The Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103642,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten situations that require you to decide if an action upholds educator integrity or harms educator integrity. After each situation, you will be presented with two flip cards that describe whether the action in the situation upholds or harms the educator’s integrity. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Educator Professional Integrity",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Correct. He acts to ensure student welfare, follows policy, and engages appropriate responders to mitigate risk."
							},
							"label": "Integrity Upheld"
						},
						{
							"id": "B",
							"back": {
								"text": "Incorrect. Ignoring the threat would compromise safety and professional duty."
							},
							"label": "Integrity Harmed"
						}
					],
					"count": 10,
					"setup": "Mr. Alvarez, a teacher, overhears two students planning an after-school fight. He documents what he heard and promptly reports the concern to administration per school policy.",
					"title": "Situation 9: Safety Concern",
					"number": 9,
					"prompt": "Does this action uphold or harm the educator’s professional integrity?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 16,
				"sourceId": 2160
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37088,
					"label": "Module 2: The Professional Educator",
					"title": "Module 2: The Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103643,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten situations that require you to decide if an action upholds educator integrity or harms educator integrity. After each situation, you will be presented with two flip cards that describe whether the action in the situation upholds or harms the educator’s integrity. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Educator Professional Integrity",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Incorrect. Sharing personal profiles with current students blurs personal and professional boundaries and can expose sensitive information."
							},
							"label": "Integrity Upheld"
						},
						{
							"id": "B",
							"back": {
								"text": "Correct. If policy allows, maintain a separate professional social media presence and follow district policy for online communication and social media usage."
							},
							"label": "Integrity Harmed"
						}
					],
					"count": 10,
					"setup": "Ms. Choi, a teacher, receives a request to connect on her personal social media account from a current student. She accepts the request.",
					"title": "Situation 10: Social Media",
					"number": 10,
					"prompt": "Does this action uphold or harm the educator’s professional integrity?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 17,
				"sourceId": 2170
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37088,
					"label": "Module 2: The Professional Educator",
					"title": "Module 2: The Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103644,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "Mr. Charawat noticed and reported an unsupervised student at the high school after school hours. The student had returned to school with their team after an away game. As a result, Ms. Tisch, the educator responsible for the team’s transportation back to the school, was reprimanded. Since then, Ms. Tisch has sent several complaints to the principal, each alleging various improprieties by Mr. Charawat. So far, the allegations have been found to be meritless.\n\nWhich of the following principles for professional educators does Ms. Tisch seem to be violating?"
				},
				"title": "Knowledge Check Question 5"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 23,
				"sourceId": 2230
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "81fdbfdf-b136-4dd9-ab79-6f6e34be50d8",
						"isCorrect": true
					},
					{
						"choiceId": "607c05f6-df60-41de-88cf-11803c9462aa",
						"isCorrect": false
					},
					{
						"choiceId": "b118090d-d0c2-46a0-8007-7d71d86f3211",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "81fdbfdf-b136-4dd9-ab79-6f6e34be50d8",
					"detailed": {
						"text": "Ms. Tisch seems to be engaging in retaliatory behavior because Mr. Charawat appropriately reported an ethical violation."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "81fdbfdf-b136-4dd9-ab79-6f6e34be50d8",
						"text": "Do not retaliate against a person for reporting an ethical violation.",
						"numFirstSelections": 0
					},
					{
						"id": "607c05f6-df60-41de-88cf-11803c9462aa",
						"text": "Avoid placing oneself in situations that involve conflicts of interest.",
						"numFirstSelections": 0
					},
					{
						"id": "b118090d-d0c2-46a0-8007-7d71d86f3211",
						"text": "Take appropriate steps quickly to avoid any risk of harm to students.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37088,
					"label": "Module 2: The Professional Educator",
					"title": "Module 2: The Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103645,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "**Why Ethical Action Matters**\n\nThe scenario illustrates how an educator’s well‑intended reluctance to intervene can unintentionally place students, a colleague, and the profession at risk. When Ms. Kim’s colleagues were reluctant to act after clear signs of concern, several ethical principles were immediately at risk, including objectivity and neutrality, ensuring student welfare, transparency in communication, integrity of the profession, and fidelity to the Code of Ethics.\n\nEthical decision making requires educators to consider factors beyond personal comfort, loyalty, and assumptions. Our obligation is not only to support colleagues but also to take reasonable and proactive steps when we believe a colleague may be nearing an ethically compromising situation: an expectation articulated in *MCEE* Principle I.B.2.\n\n**The Role of Ethical Standards**\n\nEthics codes such as the *MCEE* and your state’s educator code of conduct form a shared commitment between educators and the public. They clarify that educators are entrusted with responsibilities that extend beyond legal compliance, such as maintaining professional boundaries, preserving objectivity, and ensuring student welfare. These expectations help safeguard public trust and guide educators when facing complex or uncomfortable decisions, as in this scenario.\n\n**Professional Responsibilities Moving Forward**\n\nAs you reflect on this scenario, consider how the principles you examined, particularly student welfare and professional integrity, inform your responsibility to act. Reviewing your state’s educator code of conduct can help you understand how concerns related to student harm, impaired effectiveness, and boundary violations may trigger formal action, including a potential impact on licensure.\nThe *MCEE* serves as a companion resource when you suspect a colleague may be struggling or approaching an ethically sensitive boundary. By maintaining these principles with fidelity, educators ensure that their decisions withstand public scrutiny and uphold the trust placed in the profession.",
				"title": "Module 2 Summary"
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "module_summary",
				"language": "en-US",
				"position": 18,
				"sourceId": 2180
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37088,
					"label": "Module 2: The Professional Educator",
					"title": "Module 2: The Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103646,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "A science teacher, Mr. Reynertsen, has noticed that many other teachers use their own money to create special demonstrations in their classrooms, but he cannot afford to do so. As a result, Mr. Reynertsen has asked the principal for funds to purchase new demonstration materials for his classroom.\n\nMr. Reynertsen’s request most clearly demonstrates his commitment to which of the following ethical obligations of professional educators?"
				},
				"title": "Knowledge Check Question 4"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 22,
				"sourceId": 2220
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "c8462d04-ccd6-414b-a4d0-7888bc440828",
						"isCorrect": false
					},
					{
						"choiceId": "2405d00d-2bad-4c1b-becb-7f8d882e7227",
						"isCorrect": true
					},
					{
						"choiceId": "4be5d304-d2fb-4e15-aebd-1bad2223d818",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "2405d00d-2bad-4c1b-becb-7f8d882e7227",
					"detailed": {
						"text": "Professional educators should demonstrate commitment to advocating for equitable educational opportunities for all students. Mr. Reynertsen is right to reflect and then act because he thinks his science students do not have access to the same opportunities to learn that other students in the school have. The ethical issue is that students’ learning opportunities should not depend on whether an individual teacher can afford to buy materials with personal money."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "c8462d04-ccd6-414b-a4d0-7888bc440828",
						"text": "Acknowledge the work and contributions of colleagues who support student learning.",
						"numFirstSelections": 0
					},
					{
						"id": "2405d00d-2bad-4c1b-becb-7f8d882e7227",
						"text": "Ensure that all students have equitable educational opportunities.",
						"numFirstSelections": 0
					},
					{
						"id": "4be5d304-d2fb-4e15-aebd-1bad2223d818",
						"text": "Stay current with the latest developments in the field of instructional research.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37088,
					"label": "Module 2: The Professional Educator",
					"title": "Module 2: The Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103647,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "Ms. Keller is a new teacher who finds that the students in her class have very diverse learning needs. She is familiar with differentiated instruction, but she has limited knowledge about how to use it in the classroom.\n\nTo meet this challenge, Ms. Keller should do which of the following?"
				},
				"title": "Knowledge Check Question 3"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 21,
				"sourceId": 2210
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "c610e6b0-c6d0-4e8e-a856-a12e291e9bb7",
						"isCorrect": true
					},
					{
						"choiceId": "cb24c169-c242-40a6-8ef8-93c0b89be422",
						"isCorrect": false
					},
					{
						"choiceId": "7961c523-75f2-4296-88bf-aa8c33fc9449",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "c610e6b0-c6d0-4e8e-a856-a12e291e9bb7",
					"detailed": {
						"text": "Teachers should always be committed to ongoing professional learning, no matter where they are in their career. Ms. Keller has identified an area where she needs support, and seeking guidance from her supervisor is an appropriate professional response. Pursuing the relevant professional development is the next appropriate step."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "c610e6b0-c6d0-4e8e-a856-a12e291e9bb7",
						"text": "Seek advice from her supervisor on how to improve student learning in her classroom.",
						"numFirstSelections": 0
					},
					{
						"id": "cb24c169-c242-40a6-8ef8-93c0b89be422",
						"text": "Focus on students who have high levels of readiness and provide extra help to others if time allows.",
						"numFirstSelections": 0
					},
					{
						"id": "7961c523-75f2-4296-88bf-aa8c33fc9449",
						"text": "Teach according to her original plan, hoping that all her students will eventually catch up.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37088,
					"label": "Module 2: The Professional Educator",
					"title": "Module 2: The Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103648,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "During parent-teacher conferences, a teacher, Mr. McNaulty, places a catalog and order form for a fundraiser for his son’s baseball team on the desk and encourages parents to browse the catalog and place orders.\n\nThis scenario illustrates a violation of professional ethics because educators are expected to do which of the following?"
				},
				"title": "Knowledge Check Question 1"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 19,
				"sourceId": 2190
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "a1525bc0-ae6f-4b63-9b94-2fde505d669e",
						"isCorrect": true
					},
					{
						"choiceId": "bea6ba0d-155c-477e-a779-551198f810d9",
						"isCorrect": false
					},
					{
						"choiceId": "44529aa9-e628-400e-8996-38142c4184cc",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "a1525bc0-ae6f-4b63-9b94-2fde505d669e",
					"detailed": {
						"text": "Since Mr. McNaulty’s request happens during a parent-teacher conference, parents may feel pressure to support the fundraiser because of Mr. McNaulty’s role as their child’s educator. Even if Mr. McNaulty does not intend to pressure anyone, placing the catalog and order form on his desk and encouraging parents to buy items creates a conflict of interest and blurs professional boundaries. Educators are expected to avoid using their position for personal benefit and avoid creating the impression that families need to respond to personal requests to maintain a positive relationship with the teacher."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "a1525bc0-ae6f-4b63-9b94-2fde505d669e",
						"text": "Maintain appropriate professional boundaries to prevent conflicts of interest",
						"numFirstSelections": 0
					},
					{
						"id": "bea6ba0d-155c-477e-a779-551198f810d9",
						"text": "Limit communication with parents to school-related topics",
						"numFirstSelections": 0
					},
					{
						"id": "44529aa9-e628-400e-8996-38142c4184cc",
						"text": "Support only school-affiliated organizations",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37088,
					"label": "Module 2: The Professional Educator",
					"title": "Module 2: The Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103649,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "Ms. Greene, a middle school English teacher, joined the National Council of Teachers of English and attends its yearly convention. At this year’s convention, she attended several sessions on evidence-based strategies for supporting students’ reading comprehension and writing development. When she returns to school, Ms. Greene notices that several colleagues are struggling to support students who have difficulty analyzing complex texts. She would like to use what she learned to benefit the broader school community.\n\nWhich of the following actions would best fulfill Ms. Greene’s responsibility to the educational profession?"
				},
				"title": "Knowledge Check Question 2"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 20,
				"sourceId": 2200
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "fbc0ee8a-536a-42a2-95d2-9857470470e1",
						"isCorrect": false
					},
					{
						"choiceId": "bb43302e-344d-4901-82a1-a3e8b6ae513e",
						"isCorrect": false
					},
					{
						"choiceId": "15a3ae07-8394-4916-9bff-d2c642a104ae",
						"isCorrect": true
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "15a3ae07-8394-4916-9bff-d2c642a104ae",
					"detailed": {
						"text": "Ms. Greene uses the knowledge and resources gained from her participation in a professional organization to support her colleagues. This reflects educators’ responsibility to promote and advance the profession through participation in educational and professional organizations and through actions that positively affect teaching and learning."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "fbc0ee8a-536a-42a2-95d2-9857470470e1",
						"text": "Telling colleagues that they should join the same professional organization if they want access to effective instructional strategies",
						"numFirstSelections": 0
					},
					{
						"id": "bb43302e-344d-4901-82a1-a3e8b6ae513e",
						"text": "Keeping the materials for her own classroom use because she paid for the convention and attended on her own time",
						"numFirstSelections": 0
					},
					{
						"id": "15a3ae07-8394-4916-9bff-d2c642a104ae",
						"text": "Sharing the convention materials with her department chair and offering to help plan a professional learning session for interested colleagues",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37088,
					"label": "Module 2: The Professional Educator",
					"title": "Module 2: The Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		}
	],
	"examName": "Module 2: The Professional Educator",
	"sessionSubType": "PRACTICE_TEST",
	"publicId": "a201f97e-f5ee-4620-82ac-4c4c2ced8907",
	"sessionType": "SUMMATIVE",
	"totalTime": null
}
